/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {DppService} from '../../../../services/dpp.service';
import {
  getSubmodelMetadata,
  SubmodelType,
} from '../../../../models/dpp/submodel-types';

@Component({
  selector: 'app-submodel-viewer-dispatcher',
  templateUrl: './submodel-viewer-dispatcher.component.html',
  standalone: false,
})
export class SubmodelViewerDispatcherComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly dppService = inject(DppService);

  private routeSubscription?: Subscription;

  loading = true;
  isHandoverDocumentation = false;
  passportName: string | undefined = undefined;

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(async (params) => {
      const submodelId: string = params['submodelId'];
      this.passportName =
        this.route.snapshot.queryParamMap.get('passportName') ?? undefined;
      await this.determineSubmodelType(submodelId);
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  private async determineSubmodelType(submodelId: string): Promise<void> {
    this.loading = true;
    try {
      const submodel = await this.dppService.getSubmodel(submodelId);
      const semanticId = submodel?.semanticId?.keys?.[0]?.value;
      const metadata = getSubmodelMetadata(semanticId);
      this.isHandoverDocumentation =
        metadata?.type === SubmodelType.HANDOVER_DOCUMENTATION;
    } finally {
      this.loading = false;
    }
  }
}
